<div *ngIf="this.place != null && this.place.timing != null && this.place.timing.length != 0">
    <h4 class="schedule">{{this.getDay(this.place.startingDate)}}</h4>
    <p *ngFor="let item of place.timing">
        {{item.day}}{{item.isOnline == undefined ? "" : item.isOnline ? '(Online)' : '(Physical)'}} - {{this.getTime(item.time)}}
    </p>
    <p><strong>Note:</strong> All timings are in Cairo Local Time.</p>
</div>